import { useEffect } from 'react';

import { useCheckFlag } from 'hooks/useCheckFlag';
import { useGetServiceBr } from 'queries';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import Grid from '@mui/material/Grid';

import { ControlledSelect } from 'components/shared';
import { ControlledFlagCheckbox } from 'components/shared/ControlledFields/ControlledFlagCheckbox';

export default function ServiceBrSection() {
  const { t } = useTranslation();
  const { data: serviceBrOptions } = useGetServiceBr();
  const { control, setValue } = useFormContext();

  const isReqFlagContained = useCheckFlag(`flags`, 'SERVICE_BR_DEFAULT_FLAG');

  useEffect(() => {
    if (isReqFlagContained) {
      setValue(`serviceBrId`, null);
    }
  }, [isReqFlagContained]);

  return (
    <Grid container>
      <Grid item xs={12}>
        <ControlledFlagCheckbox
          flag="SERVICE_BR_DEFAULT_FLAG"
          name={`flags`}
          label={t('surchargesMaintenance.form.flags.SERVICE_BR_DEFAULT_FLAG')}
        />
      </Grid>
      <Grid item xs={12}>
        <ControlledSelect
          control={control}
          name="serviceBrId"
          variant="outlined"
          label={t('surchargesMaintenance.form.serviceBrId')}
          options={(isReqFlagContained ? [] : serviceBrOptions) ?? []}
        />
      </Grid>
    </Grid>
  );
}
